var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityStepFreeStandardToilet = function SvgAccessibilityStepFreeStandardToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
    d: "M13.161 9.632v7.606m2.483-7.606v7.606m4.293-7.603H8.767a1.346 1.346 0 0 1-1.343-1.207l-.742-5.342a1.346 1.346 0 0 1 1.34-1.485h12.763a1.346 1.346 0 0 1 1.336 1.505l-.847 5.34a1.346 1.346 0 0 1-1.337 1.189M6.99 4.303h14.825"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M16.33 28.399a6.52 6.52 0 0 1 1.713-4.36c.57-.606 1.231-1.043 1.725-1.729a4.74 4.74 0 0 0 .868-2.966H8.172c-.033 1.086.366 2.107.985 2.966.494.686 1.155 1.123 1.725 1.729a6.53 6.53 0 0 1 1.711 4.36"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
    d: "M20.647 19.446V18.14a.79.79 0 0 0-.788-.788H8.948a.79.79 0 0 0-.788.788v1.305M19.577 6.883h3.748"
  }))));
};
export default SvgAccessibilityStepFreeStandardToilet;